import '../../style/index.less';
import './index.less';
import "../../style/nsky/reset/message/index.less";



/** WEBPACK FOOTER **
 ** ./components/message/style/index.js
 **/